import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { sanitizeUrl } from '../../utils/sanitize';
import btnNoMute from "../../assets/img/whp-ico-speaker.svg";
import btnMute from "../../assets/img/whp-ico-speaker.svg";
import btnPrev from "../../assets/img/whp-ico-prev.svg";
import btnNext from "../../assets/img/whp-ico-next.svg";
import brnPlayPause from "../../assets/img/whp-btn-play.svg";

const VideoPlayerComponent = ({ videoCreated }) => {
    const videoRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [blobUrl, setBlobUrl] = useState(null);

    useEffect(() => {
        if (!videoCreated?.preSignedURL && videoCreated?.base64Video) {
            try {
                const byteCharacters = atob(videoCreated.base64Video);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'video/mp4' });

                const safeBlobUrl = URL.createObjectURL(blob);
                setBlobUrl(safeBlobUrl);

                return () => {
                    URL.revokeObjectURL(safeBlobUrl);
                };
            } catch (error) {
                console.error("Error al procesar el video seguro", error);
            }
        }
    }, [videoCreated?.preSignedURL, videoCreated?.base64Video]);

    const getSafeVideoUrl = (url) => {
        if (!url) return null;
        try {
            const parsedUrl = new URL(url);
            if (parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:') {
                return parsedUrl.toString();
            }
        } catch (error) {
            return null;
        }
        return null;
    };

    const safeHttpsUrl = getSafeVideoUrl(videoCreated?.preSignedURL);

    const finalVideoSrc = safeHttpsUrl || blobUrl;

    const encodedVideoSrc = finalVideoSrc ? encodeURI(finalVideoSrc) : null;

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleLoadedMetadata = () => {
            setDuration(video.duration);
        };

        const handleTimeUpdate = () => {
            setCurrentTime(video.currentTime);
        };

        video.addEventListener('loadedmetadata', handleLoadedMetadata);
        video.addEventListener('timeupdate', handleTimeUpdate);

        return () => {
            video.removeEventListener('loadedmetadata', handleLoadedMetadata);
            video.removeEventListener('timeupdate', handleTimeUpdate);
        };
    }, [finalVideoSrc]);

    const togglePlay = () => {
        const video = videoRef.current;
        if (isPlaying) {
            video.pause();
        } else {
            video.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleSkip = (seconds) => {
        const video = videoRef.current;
        video.currentTime += seconds;
    };

    const toggleMute = () => {
        const video = videoRef.current;
        video.muted = !isMuted;
        setIsMuted(!isMuted);
    };

    const handleProgressChange = (e) => {
        const video = videoRef.current;
        video.currentTime = (e.target.value / 100) * duration;
    };

    const safeVideoUrl = sanitizeUrl(videoCreated.preSignedURL, { allowData: false });
    const safeBase64Video = sanitizeUrl(`data:video/mp4;base64,${videoCreated.base64Video || ''}`, { allowData: true });

    return <>
        {encodedVideoSrc ? (
                <video 
                    src={encodedVideoSrc} 
                    className="w-100" 
                    ref={videoRef} 
                ></video>
            ) : (
                <div className="w-100 text-center p-4 bg-light">
                    <p>Cargando video o formato no soportado.</p>
                </div>
            )}
        <div className="controls w-100">
            <button className="btn btn-link d-block" onClick={toggleMute}>
                {isMuted ? <img src={btnMute} className="mute" alt="Volumen" /> : <img src={btnNoMute} className="mute" alt="Volumen" />}
            </button>
            <progress
                type="range"
                min="0"
                max="100"
                value={(currentTime / duration) * 100 || 0}
                onChange={handleProgressChange} ></progress>
            <div className="d-flex ">
                <span className="start"></span>
                <span className="end"></span>
            </div>
            <div className="buttons text-center" >
                <div>
                    <button className="btn btn-link" onClick={() => handleSkip(-5)}>
                        <img src={btnPrev} alt="prev" />
                    </button>
                    <button className="btn btn-link" onClick={togglePlay}>
                        {isPlaying ? <img src={brnPlayPause} className="play" alt="Pause" /> : <img src={brnPlayPause} className="play" alt="Play" />}
                    </button>
                    <button className="btn btn-link" onClick={() => handleSkip(5)}>
                        <img src={btnNext} alt="next" />
                    </button>
                </div>
            </div>
        </div>
    </>
};

export default VideoPlayerComponent;